<template>
  <div class="spinner-container" v-if="filteredUsersByEmailName.length === 0">
    <h1 class="spinner">Loading Users <b-spinner/></h1>
  </div>
  <div v-else class="container">
    <h1>Users Overview</h1>
    <v-search :value="searchedValue" @input="searchedValue = $event" :label="'Search:'" :placeholder="'xx@email.com'" />

    <b-form-group label="Filter By creditor Id:">
      <b-form-radio-group id="radios2" v-model="creditorFlag" name="radioSubComponent">
        <b-form-radio :value="creditorFlags.WITH_CREDITOR">With</b-form-radio>
        <b-form-radio :value="creditorFlags.WITHOUT_CREDITOR">Without</b-form-radio>
        <b-form-radio :value="creditorFlags.ALL_CREDITORS">All</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <users-table :users="filteredUsers" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_USER_ACTION } from '../../store/actionTypes';
import _ from 'lodash';
import { creditorFlags } from 'src/variable';
import UsersTable from '@/views/UsersView/components/UsersTable';
import VSearch from '@/components/ui/VSearch';

export default {
  name: 'Users',
  components: {
    UsersTable,
    VSearch,
  },
  data() {
    return {
      searchedValue: null,
      filteredUsersByEmailName: [],
      creditorFlags,
      creditorFlag: creditorFlags.ALL_CREDITORS,
    };
  },
  created() {
    this.getUsers().then(() => {
      this.filteredUsersByEmailName = this.externalUsers;
    });
    this.debounceFilterUsers = _.debounce(this.filterUsers, 200);
  },
  computed: {
    ...mapGetters(['internalUsers', 'externalUsers']),
    filteredUsers() {
      return this.filteredUsersByCreditorId();
    },
  },
  watch: {
    searchedValue() {
      this.debounceFilterUsers();
    },
  },
  methods: {
    ...mapActions({
      getUsers: GET_USER_ACTION,
    }),
    filterUsers() {
      if (!this.searchedValue) return (this.filteredUsersByEmailName = this.externalUsers);

      return (this.filteredUsersByEmailName = _.unionBy(
        this.filterUsersByEmail(),
        this.filterUsersByName(),
        (user) => user.id,
      ));
    },
    filterUsersByEmail() {
      return this.externalUsers.filter(
        (user) => user.email && user.email.toLowerCase().includes(this.searchedValue.toLowerCase()),
      );
    },
    filterUsersByName() {
      return this.externalUsers.filter((user) => {
        return (
          (user.firstName && user.firstName.toLowerCase().includes(this.searchedValue.toLowerCase())) ||
          (user.lastName && user.lastName.toLowerCase().includes(this.searchedValue.toLowerCase()))
        );
      });
    },
    filteredUsersByCreditorId() {
      switch (this.creditorFlag) {
        case creditorFlags.ALL_CREDITORS:
          return this.filteredUsersByEmailName;
        case creditorFlags.WITHOUT_CREDITOR:
          return this.filteredUsersByEmailName.filter((user) => !user.creditorId);
        case creditorFlags.WITH_CREDITOR:
          return this.filteredUsersByEmailName.filter((user) => user.creditorId);
        default:
          return this.filteredUsersByEmailName;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.spinner {
  text-align: center;

  &-container {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}

.search {
  &-container {
    display: flex;
    align-items: baseline;
    margin-bottom: 1em;
  }

  &-label {
    margin-right: 0.5em;
  }
}
</style>
